export const contractTypes = [
  { id: 1, name: "fleetMaintenance" },
  { id: 2, name: "Leasing" },
  { id: 3, name: "cashCustomer" },
];

export const ACCOUNT_FIELD_ORDER = {
  searchCompany: 0,
  contractType: 1,
  customerType: 2,
  accountName: 3,
  nameArabic: 4,
  contractNumber: 5,
  accountEmail: 6,
  contactPerson: 7,
  customerNumber: 8,
  accType: 9,
  agreedAdvancePayment: 10,
  creditLimit: 11,
  creditPeriod: 12,
  taxNumber: 13,
  schemeId: 14,
  schemeNumber: 15,
  markup: 16,
  vatPercentage: 17,
  address: 18,
  addressArabic: 19,
  district: 20,
  districtArabic: 21,
  city: 22,
  cityArabic: 23,
  country: 24,
  countryArabic: 25,
  postalCode: 26,
  category: 27,
  monthlyRevenueTarget: 28,
  yearlyRevenueTarget: 29,
  description: 100,
  searchAccountManager: 102,
  pacContractId: 103,
  installmentPayment: 105,
  repaymentPeriod: 106,
  idIssuer: 107,
  productType: 108,
  productStatus: 109,
  defaultStatus: 110,
  goodsServices: 111,
  buildingNo: 112,
  streetName: 113,
  streetNameArabic: 114,
  region: 115,
  additionalNo: 116,
  otherSellerID: 117,
  defaultSatisfactionDate: 118,
  settleDate: 118,
  accountControl: 199,
  fileUpload: 200,
  garage: 201,
  contractStartDate: 119,
  contractEndDate: 120,
  contractName: 121,
};

export const accountFieldStyle = (key, extra = {}) => ({
  order: ACCOUNT_FIELD_ORDER[key] ?? 200,
  ...extra,
});
export const statuses = [
  { value: "credit", name: "Credit" },
  { value: "advance", name: "Advance" },
];
export const accStatus = [
  { value: "B2B", name: "B2B" },
  { value: "B2G", name: "B2G" },
  { value: "internal", name: "Internal" },
  { value: "legal", name: "Legal" },
];

export const creditPeriod = [
  { key: 1, name: "0" },
  { key: 2, name: "30" },
  { key: 3, name: "45" },
  { key: 4, name: "60" },
  { key: 5, name: "90" },
  { key: 6, name: "120" },
];
export const customerTypes = [
  { key: 1, name: "garage" },
  { key: 2, name: "operation" },
  { key: 3, name: "user" },
];

export const c_schemeIdList = [
  { key: 1, name: "TIN" },
  { key: 2, name: "CRN" },
  { key: 3, name: "MOM" },
  { key: 4, name: "MLS" },
  { key: 5, name: "700" },
  { key: 6, name: "SAG" },
  { key: 7, name: "NAT" },
  { key: 8, name: "GCC" },
  { key: 9, name: "IQA" },
  { key: 10, name: "OTH" },
];

export const defaultStatusesList = [
  { key: "FS", name: "FS" },
  { key: "NS", name: "NS" },
  { key: "OS", name: "OS" },
  { key: "PP", name: "PP" },
  { key: "RG", name: "RG" },
];

export const idIssuerList = [
  { key: "CM", name: "CM" },
  { key: "CU", name: "CU" },
  { key: "CW", name: "CW" },
  { key: "EN", name: "EN" },
  { key: "FI", name: "FI" },
  { key: "GI", name: "GI" },
  { key: "IN", name: "IN" },
  { key: "MA", name: "MA" },
  { key: "MC", name: "MC" },
  { key: "MD", name: "MD" },
  { key: "ME", name: "ME" },
  { key: "MF", name: "MF" },
  { key: "MH", name: "MH" },
  { key: "MI", name: "MI" },
  { key: "MJ", name: "MJ" },
  { key: "ML", name: "ML" },
  { key: "MN", name: "MN" },
  { key: "MU", name: "MU" },
  { key: "MX", name: "MX" },
  { key: "RD", name: "RD" },
  { key: "PP", name: "PP" },
  { key: "SA", name: "SA" },
  { key: "TV", name: "TV" },
  { key: "UN", name: "UN" },
];
export const productTypeList = [
  { key: "ADFL", name: "ADFL" },
  { key: "AMTG", name: "AMTG" },
  { key: "AQAR", name: "AQAR" },
  { key: "CDC", name: "CDC" },
  { key: "CDL", name: "CDL" },
  { key: "CHC", name: "CHC" },
  { key: "CHCK", name: "CHCK" },
  { key: "COM", name: "COM" },
  { key: "CRC", name: "CRC" },
  { key: "EDUF", name: "EDUF" },
  { key: "GFC", name: "GFC" },
  { key: "IAC", name: "IAC" },
  { key: "IEN", name: "IEN" },
  { key: "ILB", name: "ILB" },
  { key: "IMD", name: "IMD" },
  { key: "IMR", name: "IMR" },
  { key: "IMTG", name: "IMTG" },
  { key: "IMV", name: "IMV" },
  { key: "IPR", name: "IPR" },
  { key: "IPS", name: "IPS" },
  { key: "LEGL", name: "LEGL" },
  { key: "LND", name: "LND" },
  { key: "MBL", name: "MBL" },
  { key: "MGLD", name: "MGLD" },
  { key: "MIS", name: "MIS" },
  { key: "MSKN", name: "MSKN" },
  { key: "MTG", name: "MTG" },
  { key: "NET", name: "NET" },
  { key: "PE", name: "PE" },
  { key: "CRC", name: "CRC" },
  { key: "PLN", name: "PLN" },
  { key: "POD", name: "POD" },
  { key: "RCSR", name: "RCSR" },
  { key: "RERA", name: "RERA" },
  { key: "RMSKN", name: "RMSKN" },
  { key: "RMTG", name: "RMTG" },
  { key: "RPLN", name: "RPLN" },
  { key: "RSMEI", name: "RSMEI" },
  { key: "RSMEL", name: "RSMEL" },
  { key: "RVIN", name: "RVIN" },
  { key: "RVLS", name: "RVLS" },
  { key: "SFB", name: "SFB" },
  { key: "SME", name: "SME" },
  { key: "SMEI", name: "SMEI" },
  { key: "SMEL", name: "SMEL" },
  { key: "SMS", name: "SMS" },
  { key: "STFM", name: "STFM" },
  { key: "TMTG", name: "TMTG" },
  { key: "TPLN", name: "TPLN" },
  { key: "TOD", name: "TOD" },
  { key: "UNFS", name: "UNFS" },
  { key: "VCLM", name: "VCLM" },
  { key: "VEHE", name: "VEHE" },
  { key: "VESP", name: "VESP" },
  { key: "VIN", name: "VIN" },
  { key: "VLS", name: "VLS" },
  { key: "VRA", name: "VRA" },
  { key: "WAT", name: "WAT" },
];
export const productStatuesList = [
  { key: "A", name: "A" },
  { key: "S", name: "S" },
  { key: "C", name: "C" },
  { key: "W", name: "W" },
  { key: "X", name: "X" },
  { key: "L", name: "L" },
];
export const goodsServicesList = [
  { key: "ALOTH", name: "ALOTH" },
  { key: "APPLN", name: "APPLN" },
  { key: "MCHNR", name: "MCHNR" },
  { key: "CARS", name: "CARS" },
  { key: "BLDMT", name: "BLDMT" },
  { key: "TRCTH", name: "TRCTH" },
  { key: "OTHFD", name: "OTHFD" },
  { key: "LMEAT", name: "LMEAT" },
  { key: "SUGTC", name: "SUGTC" },
  { key: "FRVEG", name: "FRVEG" },
];
